module.exports = __webpack_public_path__ + "static/media/icon_core.087af45c.svg";